import Reveal from '@/components/base/Reveal';

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.35em] text-primary-600">About JEDL</p>
          <h2 className="font-heading text-3xl md:text-5xl mt-6 text-foreground-950 leading-[1.1]">
            Hospitality is more than a meal.
          </h2>
          <div className="mt-8 space-y-5 text-foreground-700 leading-relaxed">
            <p>
              At JEDL Restaurants, we believe great restaurants are built around more than food. They are built
              around people, memorable experiences, thoughtful spaces, and teams who genuinely care about hospitality.
            </p>
            <p>
              Based in San Diego, JEDL develops and operates restaurant concepts designed to become part of the
              communities they serve. From all-day breakfast to coffee and casual dining, our brands share a
              commitment to quality, consistency, and making people feel welcome.
            </p>
          </div>
          <p className="mt-9 font-heading text-xl md:text-2xl text-foreground-900 italic">
            Different concepts. One approach to hospitality.
          </p>
        </Reveal>

        <Reveal delay={120}>
          <div className="relative">
            <div className="w-full h-[420px] md:h-[540px] overflow-hidden">
              <img
                src="https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/37303c22d5b9918d3ebd1d2cc58eacdf.png"
                alt="Breakfast Republic brunch spread with pancakes, french toast, breakfast potatoes and coffee"
                title="JEDL Restaurants — Breakfast Republic brunch"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-5 -left-5 md:-left-8 bg-background-50 border border-background-200 px-6 py-5 hidden sm:block">
              <p className="text-xs uppercase tracking-[0.25em] text-foreground-500">Based In</p>
              <p className="font-heading text-xl text-foreground-950 mt-1">San Diego, CA</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}